<template>
    <div class="warpper">
        <div class="info-container">
            <div class="flex align-center justify-between">
                <div class="page-title">{{detail.title}}</div>
                <div class="flex align-center">
                    <router-link class="page-operate yellow" :to="'/organization/organ/serverEdit/'+id">编辑</router-link>
                    <div class="page-back margin-left-xs" @click="deleteItem()">删除</div>
                    <div class="page-back margin-left-xs" @click="$router.go(-1)">返回</div>
                </div>
            </div>
            <div class="flex flex-wrap align-center">
                <div class="count"><span>{{detail.son.length}}</span>项服务</div>
                <div class="tag" v-for="(tag,position) in detail.label" :key="position">{{tag}}</div>
            </div>
            <div class="content margin-top-sm">{{detail.desc}}</div>
        </div>

        <div class="info-container margin-top-sm">
            <div class="menus flex">
                <div class="item-menu flex flex-direction align-center justify-center"
                     :class="{active:cur_index === index}"
                     @click="cur_index = index"
                     v-for="(menu,index) in detail.son" :key="index">
                    <div class="menu-title">{{menu.title}}</div>
                    <el-tooltip class="item" effect="light" :content="menu.content" placement="top">
                        <div class="menu-content ovHide2">{{menu.content}}</div>
                    </el-tooltip>
                    <div class="menu-count" :class="{has:menu.num}">{{menu.num ? `${menu.num}  新申请` : '无新申请'}}</div>
                </div>
            </div>

            <div class="flex align-center justify-between list-search">
                <el-select v-model="rankId" placeholder="请选择">
                    <el-option
                            v-for="item in levels"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <el-input class="margin-left-sm" v-model="searchName" placeholder="请输入企业全称/法人姓名/联系电话"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </div>

            <div class="flex flex-direction">
                <div class="item-server flex align-center"  v-for="(item,index) in lists.daiChuLidata" :key="index">
                    <div class="flex flex-direction flex-sub">
                        <div class="title ">{{item.company}}</div>
                        <div class="flex align-center margin-top-sm">
                            <div class="info">联系人：{{item.name}}</div>
                            <div class="info">联系电话：{{item.phone}}</div>
                        </div>
                        <div class="flex align-center margin-top-sm">
                            <div class="info">申请时间：{{item.add_time}}</div>
                            <div class="info">会员等级：{{item.rank_name}}</div>
                        </div>
                    </div>
                    <div class="flex align-center flex-shrink">
                        <div class="page-back" @click="changeServer(item.id)">未处理</div>
                    </div>
                </div>
            </div>

            <div class="flex align-center justify-between margin-top">
                <div class="page-title ">历史申请</div>
                <div class="page-back line" @click="delAll">全部删除</div>
            </div>
            <empty v-if="lists.yiChuLidata.length === 0" :type="2"/>
            <div class="flex flex-direction">
                <div class="item-server history flex align-center"  v-for="(item,index) in lists.yiChuLidata" :key="index">
                    <div class="flex flex-direction flex-sub">
                        <div class="title ">{{item.company}}</div>
                        <div class="flex align-center margin-top-sm">
                            <div class="info">联系人：{{item.name}}</div>
                            <div class="info">联系电话：{{item.phone}}</div>
                        </div>
                        <div class="flex align-center margin-top-sm">
                            <div class="info">申请时间：{{item.add_time}}</div>
                            <div class="info">会员等级：{{item.rank_name}}</div>
                        </div>
                    </div>
                    <div class="flex align-center flex-shrink">
                        <div class="info min">已处理</div>
                        <div class="page-back line margin-left-sm" @click="delItem(item.id)">删除</div>
                    </div>
                </div>
            </div>
        </div>
        <dispose-service-dialog :apply-dialog-visible="disposeDialogVisible" :sid="cur_id" @watchState="watchState"></dispose-service-dialog>
    </div>
</template>

<script>
    import {getServerDetail, delServer, getRankList,getServerProjectList,delApply,delAllApply} from '@/api/organiz'
    import {zhDate} from "@/utils/utils";
    import DisposeServiceDialog from "../../../../components/DisposeServiceDialog";

    export default {
        name: "serverDetail",
        data() {
            return {
                id: '',
                detail: '',
                levels: [],
                lists: [],
                rankId: '',
                searchName: '',
                cur_index: 0,
                cur_id :0,
                disposeDialogVisible:false
            }
        },
        created() {
            this.$emit('setIndex', [5, 3], '机构服务')
            this.id = Number(this.$route.params.id)
            this.init()
        },
        components: {DisposeServiceDialog},
        methods: {
            async init() {
                let _data = await getServerDetail(this.id)
                if (_data.status === 200) {
                    _data.data.label = _data.data.label ? _data.data.label.split(',') : []
                    this.detail = _data.data
                }
                let _list = await getRankList()
                if (_list.status === 200) {

                    this.levels = [{id: 0,
                        name: "全部"},..._list.data]
                }
                this.getList()
            },
            async getList() {
                let _data = await getServerProjectList(this.detail.son[this.cur_index].id,this.rankId,this.searchName)
                if (_data.status === 200) {
                    _data.data.daiChuLidata.map(item=>{
                        item.add_time = zhDate(item.add_time * 1000,2)
                    })
                    _data.data.yiChuLidata.map(item=>{
                        item.add_time = zhDate(item.add_time * 1000,2)
                    })
                    this.lists = _data.data
                }
            },
            search(){
              this.getList()
            },
            deleteItem() {
                this.$confirm("确定要删除此服务吗", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.delServer()
                })
            },
            async delServer() {
                let _data = await delServer(this.id)
                if (_data.status === 200) {
                    this.$message.success(_data.msg)
                    this.$router.go(-1)
                }
            },
            delItem(id) {
                this.$confirm("确定要删除此申请记录吗", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.delServerProject(id)
                })
            },
            async delServerProject(id) {
                let _data = await delApply(id)
                if (_data.status === 200) {
                    this.$message.success(_data.msg)
                    this.getList()
                }
            },
            changeServer(id) {
                this.cur_id = id
                this.disposeDialogVisible = true
            },
            watchState(data){
                this.disposeDialogVisible = false
              if (data) this.getList()
            },
            delAll() {
                this.$confirm("确定要删除全部申请记录吗", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.delAllServerProject()
                })
            },
            async delAllServerProject() {
                let _data = await delAllApply(this.detail.son[this.cur_index].id)
                if (_data.status === 200) {
                    this.$message.success(_data.msg)
                    this.getList()
                }
            },
        },
        filters: {},
        watch: {
            cur_index(){
                this.getList()
            }
        },
    }
</script>

<style scoped lang="scss">
    .warpper {
        .info-container {
            background-color: #ffffff;
            border-radius: 10px;
            padding: 20px;

            .item-server {
                background-color: #ffffff;
                border-radius: 10px;
                border: solid 1px #dae0e6;
                min-height: 122px;
                padding: 25px 20px;
                cursor: pointer;
                margin-top: 20px;
                .title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333333;
                }
                .info {
                    font-size: 14px;
                    color: #666666;
                    width: 300px;
                    &.min{
                        width: max-content;
                    }
                }
                &.history{
                    .title {
                        color: #999999;
                    }
                    .info {
                        color: #999999;
                    }
                }
                &:hover{
                    background-color: #f3f7fb;
                    border-radius: 10px;
                    border: solid 1px #dae0e6;
                }
            }
            .count {
                min-width: 89px;
                height: 40px;
                line-height: 40px;
                background-color: #f3f7fb;
                border-radius: 10px;
                border: solid 1px #dae0e6;
                font-size: 16px;
                color: #0a2240;
                text-align: center;
                padding: 0 12px;
                font-weight: bold;
                margin-top: 15px;
                margin-right: 20px;
                span {
                    color: #ff9600;
                }
            }
            .tag {
                min-width: 82px;
                height: 39px;
                line-height: 39px;
                background-color: #ffffff;
                border-radius: 14px;
                border: solid 1px #dae0e6;
                font-size: 14px;
                color: #999999;
                text-align: center;
                margin-top: 15px;
                margin-right: 20px;
                padding: 0 12px;
            }
            .content {
                font-size: 14px;
                line-height: 24px;
                color: #666666;
            }
            .menus {
                width: 100%;
                height: 230px;
                overflow-x: scroll;
                &::-webkit-scrollbar {
                    width: 10px;
                    height: 10px;
                    background-color: #dae0e6;
                }
                &::-webkit-scrollbar-track{
                    -webkit-box-shadow : inset 0 0 0px rgba(0 ,0 ,0,0);
                    border-radius : 3px ;
                    background-color:#ffffff ;
                }
                &::-webkit-scrollbar-thumb{
                    -webkit-box-shadow : inset 0 0 0px rgba(0 ,0 ,0,0);
                    border-radius : 3px ;
                    background-color:#dae0e6 ;
                }
                .item-menu {
                    flex-shrink: 0;
                    width: 299px;
                    height: 194px;
                    background-color: #f3f7fb;
                    border-radius: 10px;
                    padding: 20px;
                    cursor: pointer;
                    .menu-title {
                        font-size: 22px;
                        font-weight: bold;
                        line-height: 34px;
                        color: #333333;
                    }
                    .menu-content {
                        font-size: 14px;
                        line-height: 24px;
                        color: #666666;
                        opacity: 0.7;
                        margin-top: 15px;
                    }
                    .menu-count {
                        min-width: 99px;
                        height: 39px;
                        background-color: #f3f7fb;
                        border-radius: 10px;
                        border: solid 1px #0a2240;
                        padding: 0 20px;
                        line-height: 39px;
                        text-align: center;
                        font-size: 16px;
                        color: #0a2240;
                        margin-top: 20px;
                        &.has {
                            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                            linear-gradient(#f3f7fb, #f3f7fb);
                            background-blend-mode: normal, normal;
                            border-radius: 10px;
                            border: none;
                            color: #ffffff;
                        }
                    }
                    &.active {
                        background-color: #0a2240;
                        position: relative;
                        &:before {
                            position: absolute;
                            bottom: -8px;
                            border-left: 8px solid transparent;
                            border-top: 8px solid #0a2240;
                            border-right: 8px solid transparent;
                            left: 50%;
                            transform: translateX(-50%);
                            content: '';
                        }
                        .menu-title {
                            color: #ffffff;
                        }
                        .menu-content {

                            color: #ffffff;
                        }
                    }
                }
                .item-menu + .item-menu {
                    margin-left: 20px;
                }
            }
            .list-search {
                margin-top: 10px;
                .el-input__inner {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }
                .el-button {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    background: #0a2240;
                    border: 0;
                    font-size: 16px;
                }
            }
        }

    }
</style>
